import React, { Component } from "react";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import { Spin, message } from "antd";
import Bridge from "./utils/Bridge";
import PasswordNotesTooltip from "./components/PasswordNotesTooltip";
import { RESEARCH_TYPE } from "./utils/consts";
import { translateApiMessage } from "./utils/functions";

import englishJson from './utils/language/leStudy/english.json';
import spanishJson from './utils/language/leStudy/spanish.json';
import noLanguageJson from './utils/language/leStudy/noLanguage.json';

export default class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      old_password: "",
      new_password: "",
      confirm_password: "",
      confirm_type: "password",
      new_type: "password",
      old_type: "password",
      loading: false,
    };
  }
  componentDidMount() { }
  // show hide password
  togglePassword = (type) => {
    if (type == "confirm") {
      this.setState({
        confirm_type:
          this.state.confirm_type == "password" ? "text" : "password",
      });
    } else if (type == "new") {
      this.setState({
        new_type: this.state.new_type == "password" ? "text" : "password",
      });
    } else if (type == "old") {
      this.setState({
        old_type: this.state.old_type == "password" ? "text" : "password",
      });
    }
  };
  change_password = () => {
    
    const formData =
      RESEARCH_TYPE === "LE Study"
        ? this.props.language === "English"
          ? englishJson
          : this.props.language === "Spanish"
            ? spanishJson
            : noLanguageJson
        : englishJson;
    let new_password = this.state.new_password;
    let confirm_password = this.state.confirm_password;
    if (!this.state.old_password) {
      message.warning(formData.page.changePassword.messages.validation.oldPasswordRequired);
      return;
    }
    if (!new_password) {
      message.warning(formData.page.changePassword.messages.validation.newPasswordRequired);
      return;
    }
    let lowerCaseLetters = /[a-z]/g;
    let upperCaseLetters = /[A-Z]/g;
    let numbers = /[0-9]/g;
    let specialCharacters = /[!@#\$%\^&\*]/g;
    if (!new_password.match(lowerCaseLetters)) {
      message.warning(formData.page.changePassword.messages.validation.newPasswordLowercase);
      return;
    }
    if (!new_password.match(upperCaseLetters)) {
      message.warning(formData.page.changePassword.messages.validation.newPasswordUppercase);
      return;
    }
    if (!new_password.match(numbers)) {
      message.warning(formData.page.changePassword.messages.validation.newPasswordNumber);
      return;
    }
    if (!new_password.match(specialCharacters)) {
      message.warning(formData.page.changePassword.messages.validation.newPasswordSpecialChar);
      return;
    }
    if (new_password.length < 8 || new_password.length > 15) {
      message.warning(formData.page.changePassword.messages.validation.newPasswordLength);
      return;
    }
    if (!this.state.confirm_password) {
      message.warning(formData.page.changePassword.messages.validation.confirmPasswordRequired);
      return;
    }
    if (new_password !== confirm_password) {
      message.warning(formData.page.changePassword.messages.validation.passwordMismatch);
      return;
    }
    let params = {
      old_password: this.state.old_password,
      new_password: new_password,
      participant_id: localStorage.getItem("ap_id"),
      participants_accounts_id: localStorage.getItem("ap_participants_accounts_id"),
      research_type: RESEARCH_TYPE
    };
    this.setState({ loading: true });
    Bridge.change_password(params)
      .then((response) => {
        if (response.data.status == "1") {
          const language = this.props.language || localStorage.getItem("ap_language") || "English";
          message.success(translateApiMessage(response.data.message, language));
          this.setState({
            old_password: "",
            new_password: "",
            confirm_password: "",
            loading: false,
          });
        } else {
          const language = this.props.language || localStorage.getItem("ap_language") || "English";
          message.warning(translateApiMessage(response.data.message, language));
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.error("Please try again!!");
        this.setState({ loading: false });
      });
  };
  render() {
    const formData =
      RESEARCH_TYPE === "LE Study"
        ? this.props.language === "English"
          ? englishJson
          : this.props.language === "Spanish"
            ? spanishJson
            : noLanguageJson
        : englishJson;
    return (
      <div>
        <Header />
        <div
          className="main-content demographics-wrapper"
          style={{ paddingTop: 40 }}
        >
          <div className="container" style={{ minHeight: 300 }}>
            <div className="row">
              <div className="col-lg-6">
                <a href="/dashboard" className="dashboard-back-arrow mt-0">
                  <box-icon
                    name="chevron-left"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                  {formData.page.backButtonTextDashboard}
                </a>
                <Spin spinning={this.state.loading}>
                  <div className="change-password-form">
                    <h3 className="pb-0 mb-0">{formData.page.changePassword.title}</h3>
                    <hr />
                    <div className="form-group pt-4">
                      <label>
                        <box-icon
                          type="solid"
                          name="envelope"
                          color="#9e9e9e"
                          size="23px"
                          style={{ marginTop: 0, marginRight: 12 }}
                        ></box-icon>{" "}
                        {formData.page.changePassword.form.fields.oldPassword.label}
                      </label>
                      <input
                        type={this.state.old_type}
                        value={this.state.old_password}
                        onChange={(e) =>
                          this.setState({ old_password: e.target.value })
                        }
                      />
                      <div
                        className="togglePassword"
                        onClick={() => this.togglePassword("old")}
                      >
                        {this.state.old_type == "password" ? (
                          <div className="show-password-icon">
                            <box-icon name="show" color="#ffa3a3"></box-icon>
                          </div>
                        ) : (
                          <div className="show-password-icon">
                            <box-icon
                              name="low-vision"
                              color="#ffa3a3"
                            ></box-icon>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="form-group">
                      <label>
                        <box-icon
                          type="solid"
                          name="envelope"
                          color="#9e9e9e"
                          size="23px"
                          style={{ marginTop: 0, marginRight: 12 }}
                        ></box-icon>{" "}
                        {formData.page.changePassword.form.fields.newPassword.label}
                        <PasswordNotesTooltip language={this.props.language} />
                      </label>
                      <input
                        type={this.state.new_type}
                        value={this.state.new_password}
                        onChange={(e) =>
                          this.setState({ new_password: e.target.value })
                        }
                      />
                      <div
                        className="togglePassword"
                        onClick={() => this.togglePassword("new")}
                      >
                        {this.state.new_type == "password" ? (
                          <div className="show-password-icon">
                            <box-icon name="show" color="#ffa3a3"></box-icon>
                          </div>
                        ) : (
                          <div className="show-password-icon">
                            <box-icon
                              name="low-vision"
                              color="#ffa3a3"
                            ></box-icon>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="form-group">
                      <label>
                        <box-icon
                          type="solid"
                          name="envelope"
                          color="#9e9e9e"
                          size="23px"
                          style={{ marginTop: 0, marginRight: 12 }}
                        ></box-icon>{" "}
                        {formData.page.changePassword.form.fields.confirmNewPassword.label}
                      </label>
                      <input
                        type={this.state.confirm_type}
                        value={this.state.confirm_password}
                        onChange={(e) =>
                          this.setState({ confirm_password: e.target.value })
                        }
                      />
                      <div
                        className="togglePassword"
                        onClick={() => this.togglePassword("confirm")}
                      >
                        {this.state.confirm_type == "password" ? (
                          <div className="show-password-icon">
                            <box-icon name="show" color="#ffa3a3"></box-icon>
                          </div>
                        ) : (
                          <div className="show-password-icon">
                            <box-icon
                              name="low-vision"
                              color="#ffa3a3"
                            ></box-icon>
                          </div>
                        )}
                      </div>
                    </div>
                    <button
                      className="submit-button"
                      onClick={() => this.change_password()}
                    >
                      {formData.page.changePassword.form.buttons.changePassword}{" "}
                      <box-icon
                        name="chevron-right"
                        color="#fff"
                        style={{ position: "relative", top: 1 }}
                      ></box-icon>
                    </button>
                  </div>
                </Spin>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
